
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconGeneralFlag as ObiBeaconGeneralFlagElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-general-flag.js';
 
 
 

 
 export const ObiBeaconGeneralFlag = createComponent({
   react: React,
   tagName: 'obi-beacon-general-flag',
   elementClass: ObiBeaconGeneralFlagElement,
   events: {
     
   }
  });
 
 